module.exports = __webpack_public_path__ + "img/mutil.279e10ec.png";